import { Subject } from 'rxjs'

class SharedData {
  constructor() {
    this.subject = new Subject()
    this.data = {}
    this.phone_mask = ''
    this.phone_length = 0
    this.currency_symbol = ''
    this.city_branch = null
    this.chooseCityBranchDialogOpened = false
    this.city_branches = []
    this.isAddressAutocomplete = true
  }

  setProfileInfo(data) {
    this.data = data
  }

  initialize() {
    const node = document.body
    try {
       this.updateData(JSON.parse(node.getAttribute('data-shared')))
    } catch(e) {
      // this.data = {}
    }
  }

  updateData(data) {
    this.data = data
    const st = data.site_params.phone_start
    this.phone_mask = data.site_params.phone_mask
    this.phone_length = data.site_params.phone_length
    this.currency_symbol = data.site_params.currency_hash.symbol_html
    this.isAddressAutocomplete = data.site_params.is_address_autocomplete
    this.city_branches = data.site_params.city_branches
    this.city_branch = data.city_branch
    this.chooseCityBranchDialogOpened = this.city_branch == null
    this.refresh()
  }

  toggleCityBranchDialogOpened() {
    this.chooseCityBranchDialogOpened = !this.chooseCityBranchDialogOpened
    this.refresh()
  }

  refresh() {
    this.subject.next(this.data)
  }
}

const sharedData = new SharedData();

export { sharedData }



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/models/shared_data.js